import { createUseStyles } from 'react-jss'

import { paleGreen, trafficRedDark } from '../../../../../../../../styles/const/colors'
import { textEllipsisMultiline } from '../../../../../../../../styles/mixins/text'

export const inventoryTimelineLabelWidth = 66
export const timelineRowGap = 12

const useStyles = createUseStyles({
  timelineRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px'
  },
  placementLabel: {
    position: 'absolute',
    right: `calc(100% + ${timelineRowGap}px)`,
    color: '#1F2328',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    width: inventoryTimelineLabelWidth,
    flexShrink: 0,
    ...textEllipsisMultiline(2)
  },
  timelineBar: {
    display: 'flex',
    height: '24px',
    flex: 1,
    border: '1px solid #D6D6D6',
    borderRadius: '4px',
    overflow: 'hidden',
    minWidth: '200px',
    backgroundColor: paleGreen // Green background for available periods
  },
  segmentWrapper: {
    height: '24px',
    minWidth: '8px',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
    boxSizing: 'border-box',
    width: '100%',
    '&:hover': {
      opacity: 0.8
    }
  },
  available: {
    backgroundColor: 'transparent' // Let container green background show through
  },
  unavailable: {
    backgroundColor: trafficRedDark
  }
})

export default useStyles
